import { GET_PAGE, REQUEST_PAGE, UNMOUNT_PAGE, TOGGLE_FULLSCREEN } from '../actions/PageActions';

const INITIAL_STATE = {
  data: {},
  fullscreen: false,
  isFetching: false,
  pageName: '',
  documents: [],
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_PAGE:
      return {
        ...state,
        pageName: action.pageName,
        isFetching: true,
      };

    case UNMOUNT_PAGE:
      return { ...state, pageName: '' };

    case GET_PAGE:
      if (state.pageName !== action.meta.pageName) {
        return state;
      }

      return {
        ...state,
        data: action.payload.pageConfig,
        attachments: action.payload.attachments,
        isFetching: false,
      };

    case TOGGLE_FULLSCREEN:
      const fullscreen = action.fullscreen !== undefined ? action.fullscreen : !state.fullscreen;

      // Experimental stuff
      // Native fullscreen complicates esc usage
      // const page = document.getElementById('page');
      // if (fullscreen) {
      //   page.requestFullscreen();
      // } else {
      //   document.exitFullscreen();
      // }

      return {
        ...state,
        fullscreen,
      };

    default:
      return state;
  }
}
